module.exports = "/fonts/ebupot-logotype-l-bdf0cc34859f0b58f0a9d7547ca6496d.svg";